module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('v-top-advertise', {
    attrs: {
      "bigImgList": _vm.advertiseImg.bigImgList,
      "smallImgList": _vm.advertiseImg.smallImgList
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('v-product', {
    attrs: {
      "productList": _vm.productList
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer_bar"
  }, [_c('div', {
    staticClass: "change-bar"
  }, [_c('div', {
    staticClass: "c_left"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("message.language")) + "\n            :")]), _vm._v(" "), _c('div', {
    staticClass: "c_right"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.language.currentLang),
      expression: "language.currentLang"
    }],
    staticClass: "lang",
    attrs: {
      "rel": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.language, "currentLang", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeLang]
    }
  }, _vm._l((_vm.language.langList), function(lang) {
    return _c('option', {
      domProps: {
        "value": lang.code
      }
    }, [_vm._v(_vm._s(lang.languageName))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "change-bar"
  }, [_c('div', {
    staticClass: "c_left"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("message.currency")) + ":\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "c_right"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currency.currentCurrency),
      expression: "currency.currentCurrency"
    }],
    staticClass: "currency",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currency, "currentCurrency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeCurrency]
    }
  }, _vm._l((_vm.currency.currencyList), function(curry) {
    return _c('option', {
      domProps: {
        "value": curry.code
      }
    }, [_c('label', [_vm._v(_vm._s(curry.symbol))]), _vm._v(_vm._s(curry.code))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footer-bottom"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "copy"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("message.copyright")) + "©2016:\n          "), _c('a', {
    attrs: {
      "href": "http://www.fecshop.com"
    }
  }, [_vm._v("FecShop")]), _vm._v(".com\n          " + _vm._s(_vm.$t("message.allright")) + ":\n        ")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "lazy",
    attrs: {
      "src": "//img.appfront.fancyecommerce.com/images/pp.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fc32fa18!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/home/Index.vue
// module id = 271
// module chunks = 1